import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('smooth-scroll', {
    mounted(el) {
                              el.addEventListener('click', (e: Event) => {
        const targetId = el.getAttribute('href');

        if (targetId && targetId.startsWith('#')) {
          const targetElement = document.querySelector(targetId);

          if (!targetElement) {
            e.preventDefault(); // Pouze pokud element neexistuje
          }
          // Jinak necháme browser použít nativní scrolling s CSS smooth behavior
        }
      });
    }
  });
});
